import { render, staticRenderFns } from "./instructionsModal.vue?vue&type=template&id=68a81bd6&scoped=true&"
import script from "./instructionsModal.vue?vue&type=script&lang=js&"
export * from "./instructionsModal.vue?vue&type=script&lang=js&"
import style0 from "./instructionsModal.vue?vue&type=style&index=0&id=68a81bd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a81bd6",
  null
  
)

export default component.exports